"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("@react-google-maps/api");
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = __importStar(require("react"));
const MapCluster_1 = __importDefault(require("./MapCluster"));
const MapClustererContext_1 = require("./MapClustererContext");
const PinClusterer_1 = __importDefault(require("./PinClusterer"));
const DEFAULT_MIN_CLUSTER_SIZE = 3;
const MapClusterer = props => {
    const { children, minClusterSize = DEFAULT_MIN_CLUSTER_SIZE, renderPinContent, onClusterClick = noop_1.default, className, zoomOnClick, stopPropagation = true, } = props;
    const map = (0, api_1.useGoogleMap)();
    const [clusterer, setClusterer] = (0, react_1.useState)(null);
    const [clusters, setClusters] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(function initClustererEffect() {
        if (!map)
            return;
        const pinClusterer = new PinClusterer_1.default(map, [], {
            minimumClusterSize: minClusterSize,
            zoomOnClick,
        });
        pinClusterer.stopPropagation = stopPropagation;
        setClusterer(pinClusterer);
        return function cleanupClusterer() {
            try {
                setClusters([]);
                pinClusterer.clearMarkers();
                pinClusterer.setMap(null);
            }
            catch (e) { }
        };
    }, [map, minClusterSize]);
    (0, react_1.useEffect)(() => {
        if (!map || !clusterer)
            return;
        const { remove } = google.maps.event.addListener(clusterer, 'clusteringend', () => {
            setClusters(clusterer.getClusters());
        });
        setClusters(clusterer.getClusters());
        return () => {
            try {
                remove();
            }
            catch (e) { }
        };
    }, [clusterer, map]);
    return clusterer ? (react_1.default.createElement(MapClustererContext_1.MapClustererContext.Provider, { value: { clusterer } },
        children,
        react_1.default.createElement(react_1.default.Fragment, null, clusters.map((cluster, index) => {
            const center = cluster.getCenter();
            if (!center)
                return null;
            // Markers is undefined when cluster is removed from map
            return cluster.markers ? (react_1.default.createElement(MapCluster_1.default, { key: `${index}-${center.toString()}`, cluster: cluster, onClick: onClusterClick, className: className }, renderPinContent(cluster))) : null;
        })))) : null;
};
exports.default = MapClusterer;
//# sourceMappingURL=MapClusterer.js.map